<template>
  <div
    id="splash"
  >
    <div
      class="avatar"
      :style="`background-image: url(${post.channel_thumb});`"
    />

    <!-- The Video Intro: Avatar, Title and Stats. -->
    <div
      id="video-intro"
      class="wrapper"
    >
      <div class="inner">
        <h1
          class="open"
          data-panel-id="#video-meta"
        >
          {{ post.title }}
        </h1>

        <nav>
          <div
            class="video-meta open"
            data-panel-id="#video-meta"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <path d="M14 17H4v2h10v-2zm6-8H4v2h16V9zM4 15h16v-2H4v2zM4 5v2h16V5H4z" />
            </svg>
          </div>
          <span class="button empty">
            {{ post.view_count }} Views
          </span>
          <a
            class="button black subscribe"
            :href="`https://www.youtube.com/channel/${post.cid}?sub_confirmation=1`"
            target="_blank"
          >
            Subscribe<span>: {{ post.channel_subscriber_count }}</span>
          </a>
        </nav>
      </div>
    </div>

    <!-- The Video: Background and embed. -->
    <div id="video">
      <!-- The Background -->
      <div
        class="background"
        :style="`background-image: url(https://i.ytimg.com/vi/${post.pid}/maxresdefault.jpg);`"
      />

      <!-- Use the ".display-video" class to increment the video plays and to use the YouTube player API. -->
      <div class="display-video play-video">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
        >
          <path d="M8 5v14l11-7z" />
        </svg>
      </div>

      <!-- Use the ".stop-video" class to stop the video and remove the ".video-displayed" body class. -->
      <div class="stop-video">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
        >
          <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
        </svg>
      </div>

      <!-- The Video Embed: Embedded via the YouTube player API. -->
      <div class="video">
        <div class="embed">
          <!-- Replaced by the YouTube player API. -->
          <!-- <div id="player" /> -->
          <VideoPlyrSplashPlayer
            v-if="visible"
            :video="post"
          />
        </div>
      </div>
    </div>

    <!-- The Footer & Social Links -->
    <div
      id="footer"
      class="wrapper"
    >
      <div class="inner">
        <!-- MAD Footer: Use $mad_footer_text to display the default MAD link and text. -->
        <h3>
          <a
            href="https://localhost:8080"
            target="_blank"
          >
            Design by MAD
          </a>
        </h3>

        <div class="meta">
          <span>by {{ post.channel_title }}</span>

          <div class="block date">
            <Timeago
              locale="en"
              :datetime="post.published_at"
              :converter-options="{ includeSeconds: false, addSuffix: true }"
            />
          </div>

          <div class="block views">
            {{ post.view_count }} views
          </div>

          <div class="block duration">
            {{ post.duration_str }}
          </div>

          <div class="social">
            <!-- Use the ".social-share" class to launch social links in a pop-up. -->
            <a
              class="social-share"
              :href="`https://twitter.com/share?url=${twitterShareFragment}`"
            >
              Tw
            </a>
            <a
              class="social-share"
              :href="`http://www.facebook.com/sharer.php?s=100&p${facebookShareFragment}`"
            >
              Fb
            </a>
          </div>
        </div>
      </div>
    </div>

    <!-- The Video Description Side Panel: Displayibng all the video info. -->
    <div
      id="video-meta"
      class="side"
    >
      <span class="close">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
        >
          <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
        </svg>
      </span>

      <div class="inner">
        <!-- Wrap in ".video-description" to autolinkify URL's in the description. -->
        <div class="video-description">
          {{ post.description }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import postLoader from '@/mixins/fetcher/loaders/admin/post-loader';

export default {

  components: {
    VideoPlyrSplashPlayer: () => import('@/components/video/VideoPlyrSplashPlayer'),
  },

  mixins: [
    postLoader, //
  ],

  data() {
    return {
      visible: false,
      shareUrl: 'https://localhost:8080/splash/',
      shareVia: 'getMAD',
    };
  },

  computed: {
    twitterShareFragment() {
      return `${this.shareUrl}${this.post.pid}&text=${this.post.title}&via=${this.shareVia}`;
    },
    facebookShareFragment() {
      return `[url]=${this.shareUrl}${this.post.pid}&p[summary]=${this.post.title}`;
    },
  },

  mounted() {
    this.init();
  },

  methods: {
    init() {
      $('.open').on('click', () => {
        $('.side').addClass('active');
        $('body').addClass('reading');
      });

      $('.close').on('click', () => {
        $('.side').removeeClass('active');
        $('body').removeClass('reading');
      });

      $('.display-video').on('click', () => {
        $('body').addClass('video-displayed');
        this.visible = true;
      });

      $('.stop-video').on('click', () => {
        $('body').removeClass('video-displayed');
        $('body').removeClass('video-unstarted');
        $('body').removeClass('video-ended');
        $('body').removeClass('video-playing');
        $('body').removeClass('video-paused');
        $('body').removeClass('video-buffering');
        $('body').removeClass('video-cued');
        this.visible = false;
      });
    },
  },
};
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900');

*,
*:before,
*:after {
  margin: 0;
  padding: 0;
  border: 0;
  box-sizing: border-box;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
  -webkit-tap-highlight-color: transparent;
}
ol,
ul {
  list-style: none;
}
blockquote {
  quotes: none;
}
blockquote:before,
blockquote:after {
  content: none;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}
html,
body {
  width: 100%;
  height: 100%;
}
a,
a img,
a:before,
a:after {
  text-decoration: none;
  transition-duration: 0.25s;
}
canvas {
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}
video::-webkit-media-controls-start-playback-button {
  display: none !important;
}
input {
  border: none;
  border-radius: 0;
  background: none;
  outline: none;
  resize: none;
  position: relative;
  padding: 0;
  -webkit-appearance: none;
}
*:focus {
  outline: 0;
}
.pulse {
  animation-name: pulse;
  animation-duration: 1s;
  animation-fill-mode: both;
}
@keyframes pulse {
  from {
    transform: scale3d(1, 1, 1);
  }
  50% {
    transform: scale3d(1.25, 1.25, 1.25);
  }
  to {
    transform: scale3d(1, 1, 1);
  }
}
.shake {
  animation-name: shake;
  animation-duration: 1s;
  animation-fill-mode: both;
}
@keyframes shake {
  from,
  to {
    transform: translate3d(0, 0, 0);
  }
  10%,
  30%,
  50%,
  70%,
  90% {
    transform: translate3d(-3px, 0, 0);
  }
  20%,
  40%,
  60%,
  80% {
    transform: translate3d(3px, 0, 0);
  }
}
.flash {
  animation-name: flash;
  animation-duration: 0.5s;
  animation-fill-mode: both;
  animation-iteration-count: infinite;
}
@keyframes flash {
  0% {
    opacity: 0.5;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.5;
  }
}
.fadein {
  animation-name: fadein;
  animation-duration: 0.5s;
  animation-fill-mode: both;
}
@keyframes fadein {
  0% {
    opacity: 0;
    visibility: hidden;
  }
  100% {
    opacity: 1;
    visibility: visible;
  }
}
.fadeout {
  animation-name: fadeout;
  animation-duration: 0.5s;
  animation-fill-mode: both;
}
@keyframes fadeout {
  0% {
    opacity: 1;
    visibility: visible;
  }
  100% {
    opacity: 0;
    visibility: hidden;
  }
}
.fadeinup {
  animation-name: fadeinup;
  animation-duration: 0.5s;
  animation-fill-mode: both;
}
@keyframes fadeinup {
  from {
    opacity: 0;
    transform: translate3d(0, 10px, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}
.fadeoutup {
  animation-name: fadeoutup;
  animation-duration: 0.5s;
  animation-fill-mode: both;
}
@keyframes fadeoutup {
  from {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
  to {
    opacity: 0;
    transform: translate3d(0, -10px, 0);
  }
}
.fadeindown {
  animation-name: fadeindown;
  animation-duration: 0.5s;
  animation-fill-mode: both;
}
@keyframes fadeindown {
  from {
    opacity: 0;
    transform: translate3d(0, -10px, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}
.fadeoutdown {
  animation-name: fadeoutdown;
  animation-duration: 0.5s;
  animation-fill-mode: both;
}
@keyframes fadeoutdown {
  from {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
  to {
    opacity: 0;
    transform: translate3d(0, 10px, 0);
  }
}
@keyframes fadeinright {
  from {
    opacity: 0;
    transform: translate3d(100%, 0, 0);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
.fadeinright {
  animation-name: fadeinright;
  animation-duration: 0.5s;
  animation-fill-mode: both;
}
@keyframes fadeoutright {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: translate3d(100%, 0, 0);
  }
}
.fadeoutright {
  animation-name: fadeoutright;
  animation-duration: 0.5s;
  animation-fill-mode: both;
}
@keyframes fadeinleft {
  from {
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
.fadeinleft {
  animation-name: fadeinleft;
  animation-duration: 0.5s;
  animation-fill-mode: both;
}
@keyframes fadeoutleft {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
  }
}
.fadeoutleft {
  animation-name: fadeoutleft;
  animation-duration: 0.5s;
  animation-fill-mode: both;
}
@keyframes bounce {
  from,
  20%,
  53%,
  80%,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
  to {
    opacity: 0;
  }
  40%,
  43% {
    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    transform: translate3d(0, -5px, 0);
    opacity: 1;
  }
  70% {
    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    transform: translate3d(0, -2px, 0);
    opacity: 0.5;
  }
  90% {
    transform: translate3d(0, -1px, 0);
    opacity: 0;
  }
}
.bounce {
  animation-name: bounce;
  transform-origin: center bottom;
  animation-duration: 1s;
  animation-fill-mode: both;
}
@keyframes bouncedown {
  0% {
    transform: translate(-50%, -5px);
    opacity: 0.25;
  }
  40% {
    transform: translate(-50%, 0);
    opacity: 1;
  }
  100% {
    transform: translate(-50%, -5px);
    opacity: 0.25;
  }
}
@keyframes pulse {
  0% {
    transform: scale3d(0.9, 0.9, 0.9);
  }
  70% {
    transform: scale3d(1, 1, 1);
    box-shadow: 0 0 0 50px rgba(255, 255, 255, 0);
  }
  100% {
    transform: scale3d(0.9, 0.9, 0.9);
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
  }
}
body {
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  font-weight: 300;
  line-height: 1.75;
  color: #605f5f;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
}
body a {
  color: #131313;
}
body h1,
body h2,
body h3 {
  font-weight: 400;
}
body h1 {
  font-size: 18px;
}
.button {
  height: 30px;
  position: relative;
  padding: 0 15px;
  border-radius: 30px;
  font-size: 12px;
  font-weight: 700;
  line-height: 30px;
  letter-spacing: 1px;
  text-transform: uppercase;
  transition-duration: 0.25s;
  cursor: pointer;
}
.button:hover {
  transform: scale3d(1.025, 1.025, 1.025);
}
.button.outline {
  border: 2px solid;
  line-height: 26px;
}
.button.empty {
  font-weight: 700;
  padding: 0;
  box-shadow: none;
}
.button.empty:hover {
  transform: translate(0, 0);
  opacity: 0.75;
}
.button.white {
  background-color: #ffffff;
  color: #131313;
}
.button.white.outline {
  background: none;
  border-color: #ffffff;
  color: #ffffff;
}
.button.white.empty {
  background: none;
  border-color: rgba(255, 255, 255, 0);
  color: #ffffff;
}
.button.black {
  background-color: #131313;
  color: #ffffff;
}
.button.black.outline {
  background: none;
  border-color: #131313;
  color: #131313;
}
.button.red {
  background-color: #ff003a;
  color: #ffffff;
}
.button.red.outline {
  background: none;
  border-color: #ff003a;
  color: #131313;
}
.button.twitter:hover {
  background-color: #499fec;
  color: #ffffff;
}
.button.twitter:hover.empty {
  background: none;
  color: #499fec;
}
.button.twitter:hover.outline {
  background: none;
  border-color: #499fec;
  color: #499fec;
}
.button.facebook:hover {
  background-color: #4966ad;
  color: #ffffff;
}
.button.facebook:hover.empty {
  background: none;
  color: #4966ad;
}
.button.facebook:hover.outline {
  background: none;
  border-color: #4966ad;
  color: #4966ad;
}
.wrapper {
  width: 100vw;
  float: left;
}
.wrapper .inner {
  width: 80vw;
  float: left;
  position: relative;
  margin: 0 10vw;
}
@media (max-width: 820px) {
  .wrapper .inner {
    width: 90vw;
    margin: 0 5vw;
  }
}
#channel-banner {
  width: 100%;
  height: 200px;
  float: left;
  background-size: cover;
  background-position: center center;
}
.avatar {
  width: 120px;
  height: 120px;
  position: fixed;
  z-index: 20;
  top: calc(10vh - 30px);
  left: 10vw;
  border-radius: 50%;
  background-size: cover;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
  animation-name: fadeindown;
  animation-duration: 0.5s;
  animation-fill-mode: both;
}
@media (max-width: 820px) {
  .avatar {
    width: 90px;
    height: 90px;
    top: calc(10vh - 25px);
    left: 5vw;
  }
}
@media (max-width: 480px) {
  .avatar {
    width: 80px;
    height: 80px;
    top: calc(100vh - 130px);
    left: 50%;
    margin-left: -40px;
  }
}
.video-displayed .avatar,
.reading .avatar {
  animation-name: fadeoutup;
  visibility: hidden;
}
#video-intro {
  position: fixed;
  z-index: 10;
  top: 10vh;
  left: 0;
  background-color: #ffffff;
  animation-name: fadeindown;
  animation-duration: 0.5s;
  animation-fill-mode: both;
}
@media (max-width: 480px) {
  #video-intro {
    top: 5vh;
  }
}
#video-intro .inner {
  height: 60px;
  white-space: nowrap;
}
@media (max-width: 820px) {
  #video-intro .inner {
    height: 40px;
  }
}
#video-intro .inner h1 {
  width: calc(100% - 480px);
  float: left;
  margin-left: 135px;
  line-height: 60px;
  color: #131313;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  transition-duration: 0.25s;
}
@media (max-width: 980px) {
  #video-intro .inner h1 {
    width: calc(100% - 420px);
    font-size: 14px;
  }
}
@media (max-width: 820px) {
  #video-intro .inner h1 {
    margin-left: 105px;
    line-height: 40px;
  }
}
@media (max-width: 720px) {
  #video-intro .inner h1 {
    width: calc(100% - 240px);
  }
}
@media (max-width: 480px) {
  #video-intro .inner h1 {
    width: calc(100% - 140px);
    margin: 0;
  }
}
#video-intro .inner h1:hover {
  transform: translateX(3px);
}
#video-intro .inner nav {
  position: absolute;
  top: 15px;
  right: 0;
}
@media (max-width: 820px) {
  #video-intro .inner nav {
    top: 5px;
  }
}
#video-intro .inner nav .video-meta {
  width: 30px;
  height: 30px;
  float: left;
  position: relative;
  cursor: pointer;
  transition-duration: 0.25s;
}
@media (max-width: 720px) {
  #video-intro .inner nav .video-meta {
    display: none;
  }
}
#video-intro .inner nav .video-meta:hover {
  transform: scale3d(1.1, 1.1, 1.1);
}
#video-intro .inner nav .video-meta svg {
  height: 32px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  fill: #131313;
  transition-duration: 0.25s;
}
#video-intro .inner nav .button {
  float: left;
  margin-left: 15px;
}
@media (max-width: 980px) {
  #video-intro .inner nav .button span {
    display: none;
  }
}
@media (max-width: 720px) {
  #video-intro .inner nav .button.empty {
    display: none;
  }
}
.video-displayed #video-intro,
.reading #video-intro {
  animation-name: fadeoutup;
  visibility: hidden;
}
#video {
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 5;
  top: 0;
  left: 0;
}
#video .background {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 25;
  background-size: cover;
  background-position: center center;
  transition-duration: 0.5s;
  animation-name: fadein;
  animation-duration: 0.5s;
  animation-fill-mode: both;
}
#video .background:after {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-image: linear-gradient(to bottom, rgba(1, 1, 1, 0), rgba(1, 1, 1, 0.75));
  content: '';
  transition-duration: 0.5s;
}
#video .display-video {
  width: 50px;
  height: 50px;
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 30;
  margin: -25px 0 0 -25px;
  background-color: #ffffff;
  border-radius: 50%;
  cursor: pointer;
  animation: pulse 2s infinite;
  box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.5);
  transition-duration: 0.25s;
}
@media (max-width: 800px) {
  #video .display-video {
    width: 40px;
    height: 40px;
  }
}
#video .display-video svg {
  height: 30px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  fill: #000000;
  transition-duration: 0.25s;
}
@media (max-width: 800px) {
  #video .display-video svg {
    height: 25px;
  }
}
#video .display-video:hover svg {
  fill: #ff003a;
}
#video .stop-video {
  width: 60px;
  height: 60px;
  position: fixed;
  z-index: 30;
  top: 0;
  right: 0;
  background-color: rgba(19, 19, 19, 0.5);
  opacity: 0;
  transition-duration: 0.5s;
  cursor: pointer;
}
#video .stop-video svg {
  height: 20px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  fill: #ffffff;
  transition-duration: 0.25s;
}
#video .stop-video:hover svg {
  opacity: 0.5;
}
#video .video {
  box-shadow: 0 15px 35px rgba(50, 50, 93, 0.1), 0 5px 15px rgba(0, 0, 0, 0.07);
  width: 75vw;
  position: absolute;
  z-index: 20;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0;
}
@media (max-width: 980px) {
  #video .video {
    width: 90vw;
  }
}
#video .video:after {
  padding-top: 56.25%;
  display: block;
  content: '';
}
#video .video .embed {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 25;
  top: 0;
  left: 0;
}
#video .video .embed iframe {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 30;
  top: 0;
  left: 0;
}
.video-displayed #video .background {
  z-index: 20;
  transform: scale3d(1.2, 1.2, 1.2);
}
.video-displayed #video .background:after {
  background-image: linear-gradient(to bottom, rgba(1, 1, 1, 0.5), rgba(1, 1, 1, 0.75));
}
.video-displayed #video .display-video {
  opacity: 0;
  z-index: 20;
}
.video-displayed #video .stop-video {
  opacity: 1;
}
.video-displayed #video .video {
  z-index: 25;
  animation-name: fadein;
  animation-duration: 0.5s;
  animation-fill-mode: both;
}
.video-playing #video .background {
  transform: scale3d(1.4, 1.4, 1.4);
}
.reading #video .background {
  left: -400px;
}
.reading #video .background:after {
  background-image: linear-gradient(to bottom, rgba(1, 1, 1, 0.5), rgba(1, 1, 1, 0.75));
}
.reading #video .display-video {
  opacity: 0;
}
.side {
  width: 500px;
  height: 100vh;
  position: fixed;
  z-index: 50;
  top: 0;
  right: -500px;
  background-color: #ffffff;
  visibility: hidden;
  transition-duration: 0.5s;
  overflow: scroll;
}
@media (max-width: 500px) {
  .side {
    width: 100vw;
  }
}
.side.active {
  right: 0;
  visibility: visible;
}
.side .close {
  width: 60px;
  height: 60px;
  position: fixed;
  z-index: 60;
  top: 0;
  right: 0;
  background-color: rgba(19, 19, 19, 0.025);
  transition-duration: 0.5s;
  cursor: pointer;
}
.side .close svg {
  height: 20px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  fill: #131313;
  transition-duration: 0.25s;
}
.side .close:hover svg {
  opacity: 0.5;
}
.side .inner {
  width: 100%;
  float: left;
  padding: 10%;
}
#video-meta .inner .video-description {
  font-size: 16px;
}
#video-meta .inner .video-description a {
  font-weight: 400;
}
#footer {
  height: 60px;
  position: fixed;
  z-index: 10;
  bottom: 2px;
  left: 0;
  color: #ccc;
  animation-name: fadeinup;
  animation-duration: 0.5s;
  animation-fill-mode: both;
}
#footer .inner {
  border-top: 2px solid rgba(255, 255, 255, 0.25);
  padding-top: 15px;
}
#footer .inner a {
  color: #b3b2b2;
  font-weight: 700;
}
#footer .inner a:hover {
  color: #ffffff;
}
#footer .inner h3 {
  float: left;
}
@media (max-width: 720px) {
  #footer .inner h3 {
    display: none;
  }
}
#footer .inner .meta {
  float: right;
}
@media (max-width: 720px) {
  #footer .inner .meta {
    width: 100%;
  }
}
#footer .inner .meta .block {
  height: 25px;
  float: left;
  margin-left: 1px;
  padding: 0 8px;
  border-radius: 3px;
  background-color: rgba(19, 19, 19, 0.5);
  color: #b3b2b2;
  font-weight: 700;
}
#footer .inner .meta .block.views {
  display: none;
}
@media (max-width: 720px) {
  #footer .inner .meta .block.views {
    display: block;
  }
}
@media (max-width: 580px) {
  #footer .inner .meta .block.date {
    display: none;
  }
}
@media (max-width: 480px) {
  #footer .inner .meta .block.duration,
  #footer .inner .meta .block.views {
    display: none;
  }
}
#footer .inner .meta .social {
  float: left;
}
@media (max-width: 720px) {
  #footer .inner .meta .social {
    float: right;
  }
}
#footer .inner .meta span {
  float: left;
  margin-right: 14px;
}
#footer .inner .meta a {
  float: left;
  margin-left: 15px;
}
.video-displayed #footer,
.reading #footer {
  animation-name: fadeoutdown;
}
</style>
